import { render, staticRenderFns } from "./ChooseTypeOfOrder.vue?vue&type=template&id=5716b7c3&scoped=true&"
import script from "./ChooseTypeOfOrder.vue?vue&type=script&lang=js&"
export * from "./ChooseTypeOfOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTypeOfOrder.vue?vue&type=style&index=0&id=5716b7c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716b7c3",
  null
  
)

export default component.exports